// extracted by mini-css-extract-plugin
module.exports = {"centerImg":"fail_centerImg__1SSIn","btnToMyorder":"fail_btnToMyorder__3qG4b"};